import React from "react";
import {FormattedMessage} from "react-intl";
import EmptyCard from "../../hoc/EmptyCard";
import Amount from "../Utils/Amount";
import Icon from "../Utils/Icon";
import classes from "./styles.module.css";

function PayoutsDetailAmounts({success = 0, failed = 0, other = 0, currency = "RUB"}) {
    return (
        <EmptyCard>
            <div className={classes.Row}>
                <div className={classes.Success}>
                    <div className={classes.SuccessIcon}>
                        <Icon icon="checkmark1" size="20px"/>
                    </div>
                    <div>
                        <span className={classes.Label}>
                            <FormattedMessage id="PayoutsDetailAmounts.label.success"
                                              defaultMessage="Сумма выплаченных:"/>
                        </span>
                        <Amount amount={success} currency={currency}/>
                    </div>
                </div>

                <div className={classes.Failed}>
                    <div className={classes.FailedIcon}>
                        <Icon icon="cross" size="20px"/>
                    </div>
                    <div>
                        <span className={classes.Label}>
                            <FormattedMessage id="PayoutsDetailAmounts.label.failed"
                                              defaultMessage="Сумма невыплаченных:"/>
                        </span>
                        <Amount amount={failed} currency={currency}/>
                    </div>
                </div>

                <div className={classes.Other}>
                    <div className={classes.OtherIcon}>
                        <Icon icon="stopwatch" size="20px"/>
                    </div>
                    <div>
                        <span className={classes.Label}>
                            <FormattedMessage id="PayoutsDetailAmounts.label.other" defaultMessage="Сумма отложенных:"/>
                        </span>
                        <Amount amount={other} currency={currency}/>
                    </div>
                </div>
            </div>
        </EmptyCard>
    );
}

export default PayoutsDetailAmounts;



// WEBPACK FOOTER //
// ./src/Components/PayoutsDetailAmounts/index.js